var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffercat5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 17.1429H56.1L44.5421 2.57357C43.9049 1.77063 43.0968 1.12244 42.1776 0.676963C41.2584 0.231489 40.2516 0.000128582 39.2318 0H16.5038C13.7233 0 11.2232 1.70679 10.1904 4.31036L5.1 17.385C2.17175 18.15 0 20.8082 0 24V36C0 36.9471 0.76075 37.7143 1.7 37.7143H6.8C6.8 43.395 11.3666 48 17 48C22.6334 48 27.2 43.395 27.2 37.7143H40.8C40.8 43.395 45.3666 48 51 48C56.6334 48 61.2 43.395 61.2 37.7143H66.3C67.2393 37.7143 68 36.9471 68 36V27.4286C68 21.7479 63.4334 17.1429 57.8 17.1429ZM17 42.8571C14.1876 42.8571 11.9 40.5504 11.9 37.7143C11.9 34.8782 14.1876 32.5714 17 32.5714C19.8124 32.5714 22.1 34.8782 22.1 37.7143C22.1 40.5504 19.8124 42.8571 17 42.8571ZM24.65 17.1429H12.4238L16.5038 6.85714H24.65V17.1429ZM29.75 17.1429V6.85714H39.2318L47.3918 17.1429H29.75ZM51 42.8571C48.1876 42.8571 45.9 40.5504 45.9 37.7143C45.9 34.8782 48.1876 32.5714 51 32.5714C53.8124 32.5714 56.1 34.8782 56.1 37.7143C56.1 40.5504 53.8124 42.8571 51 42.8571Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffercat5);
export default __webpack_public_path__ + "static/media/offercat5.7bd7364321bc4ebd40180d628d142a8f.svg";
export { ForwardRef as ReactComponent };